import { activate, deactivate } from '../css-transition-helper/css-transition-helper';
import addDelegateEventListener from '../utility-functions/add-delegate-event-listener';

const GROUP_PARENT_SELECTOR = '[data-group-parent]';
const GROUP_SELECTOR = '[data-group]';
const GROUP_ID_SELECTOR = '[data-groupid]';

export const getGroupParent = elm => elm.closest(GROUP_PARENT_SELECTOR);
//export const hideAllGroups = elements => Promise.all([Array.from(elements).map(deactivate)]);
export const hideAllGroups = elements => {
    elements.forEach(elm => {
        elm.classList.remove('is-visible');
    });
};
export const showGroup = elm => elm.classList.add('is-visible');
export const getGroupId = elm => elm.dataset.groupid;
export const getAllGroups = context => context.querySelectorAll(GROUP_SELECTOR) as NodeListOf<HTMLElement>;
export const showGroupById = (context:HTMLElement|Document = document, groupId) => {

    const group = context.querySelector(`[data-group='${groupId}']`);
    if (!group) {
        console.log('Error: No Group Exists With This Id');
        return;
    }

    return showGroup(group);
    //return activate(group);
};

export const setupGroupHelper = (context:HTMLElement, callback:Function) => {

    addDelegateEventListener(context, 'click', GROUP_ID_SELECTOR, async event => {

        const groupId = getGroupId(event.delegateTarget);
        const groupParent = context;
        const allGroups = getAllGroups(groupParent);

        // is group already open

        hideAllGroups(allGroups);
        showGroupById(context, groupId);

        if (callback) {
            callback({
                groupId: groupId,
                groupParent: groupParent,
                allGroups: allGroups
            });
        }

    }, false);
};